import React, { useState } from "react";

const ProductDisplay = () => {
  const [loading, setLoading] = useState(false);

  const handleCheckout = async () => {
    setLoading(true);
  
    try {
      const payload = {
          productName: "Stubborn Attachments",
          price: 20,
          quantity: 1,
          customerEmail: "john.doe@example.com",
      };
  
      const response = await fetch("https://atabackend.quindl.com/create-checkout-session", {
          method: "POST",
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
      });
  
      if (!response.ok) {
          throw new Error("Failed to create checkout session");
      }
  
      const data = await response.json();
      setTimeout(() => {
          window.location.href = data.url;
      }, 1000);
  } catch (error) {
      console.error("Checkout failed:", error);
      alert("Something went wrong. Please try again.");
  } finally {
      setLoading(false);
  }
  
  };
  
  return (
    <section>
      <div className="product">
        <img
          src="https://i.imgur.com/EHyR2nP.png"
          alt="The cover of Stubborn Attachments"
        />
        <div className="description">
          <h3>Stubborn Attachments</h3>
          <h5>$20.00</h5>
        </div>
      </div>
      <button
        onClick={handleCheckout}
        className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
        disabled={loading}
      >
        {loading ? "Processing..." : "Checkout"}
      </button>
    </section>
  );
};

export default ProductDisplay;
